exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selWidth[data-v-57d67a7f] {\n  width: 300px;\n}\n.color_red[data-v-57d67a7f] {\n  color: #f5222d;\n}\n.color_green[data-v-57d67a7f] {\n  color: #7abe5c;\n}\n", ""]);

// exports
